export default "__VITE_ASSET__fUOsu4V6__"